import React from 'react';
import { useAnalytics } from '@melio/platform-analytics';

import { FullScreenContainer } from '@/cl/components/FullScreenContainer/FullScreenContainer.component';
import { usePlatformIntl } from '@/translations/Intl';
import { errorToOnboardingError, OnboardingErrorType, onboardingErrorTypeToPathValues } from '@/utils/onboarding.utils';
import { ErrorPage } from '@/widgets/error-page/ErrorPage.widget';

type OnboardingErrorProps = {
  error?: unknown;
  backToPartnerUrl: string;
  isBackToPartner?: boolean;
};

export const OnboardingError = ({ error, backToPartnerUrl, isBackToPartner }: OnboardingErrorProps) => {
  const { formatMessage } = usePlatformIntl();
  const { type } = errorToOnboardingError(error);
  const { title, message } = onboardingErrorTypeToPathValues(type);
  const { track } = useAnalytics();

  const onClick = () => {
    track('ExitFromPlatformBackButton', 'Chose');
    window.location.href = backToPartnerUrl;
  };

  const primaryButtonProps = {
    onClick,
    text: isBackToPartner
      ? formatMessage(`widgets.onboarding.errorPage.button.back`)
      : formatMessage(`widgets.onboarding.errorPage.button`),
  };

  return (
    <FullScreenContainer centered>
      <ErrorPage
        title={formatMessage(title)}
        message={formatMessage(message)}
        primaryButton={type !== OnboardingErrorType.Forbidden ? primaryButtonProps : undefined}
      />
    </FullScreenContainer>
  );
};
